module.exports = __webpack_public_path__ + "static/media/CNA.39ad3f2d.webp";